import { Controller } from "@hotwired/stimulus"
import { RangePlugin } from '@easepick/range-plugin'
import { LockPlugin } from '@easepick/lock-plugin'
import { easepick } from '@easepick/bundle'
import { getValidatedSearchFormState } from '../utils/dateStorage'

export default class extends Controller {
  static targets = ["dateInput", "dateDisplay", "startDate", "endDate"]

  connect() {
    this.initDatePicker()
    this.checkDateQueries()
  }

  initDatePicker() {
    try {
      // Check if dateInputTarget exists
      if (!this.dateInputTarget) {
        console.error('Date input target not found')
        return
      }

      const picker = new easepick.create({
        element: this.dateInputTarget,
        css: [
          'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'
        ],
        zIndex: 10,
        plugins: [RangePlugin, LockPlugin],
        RangePlugin: {
          tooltipNumber(num) {
            return num - 1;
          },
          locale: {
            one: 'night',
            other: 'nights',
          },
        },
        LockPlugin: {
          minDate: new Date(),
        },
        darkMode: true,
        lang: 'en-US',
        format: 'YYYY-MM-DD',
        autoApply: true,
        theme: 'dark-theme',
        setup(picker) {
          picker.on("render", () => {
            const shadowRoot = picker.ui.shadowRoot || picker.ui;
            if (shadowRoot) {
              let style = shadowRoot.querySelector("#custom-easepick-style");
              if (!style) {
                style = document.createElement("style");
                style.id = "custom-easepick-style";
                style.textContent = `
            .calendar>.days-grid>.day.start { background-color: black !important; }
            .calendar>.days-grid>.day.end { background-color: black !important; }
            .calendar>.days-grid>.day:hover { background-color: #e3e3e3 !important; color: black !important; }
            .calendar>.days-grid>.day.in-range { background-color: #525252 !important; color: white !important; }
          `;
                shadowRoot.appendChild(style);
              }
            }
          });
        }
      })

      // Store the picker instance for later use
      this.picker = picker
    } catch (error) {
      console.error('Error initializing date picker:', error)
      return // Exit if initialization fails
    }

    // Exit if picker wasn't created successfully
    if (!this.picker) {
      console.error('Failed to initialize date picker')
      return
    }

    // Handle date selection
    this.picker.on('select', (e) => {
      try {
        const pickerInstance = this.picker;
        let startDate, endDate;

        if (pickerInstance && pickerInstance.datePicked && pickerInstance.datePicked.length > 0) {
          startDate = pickerInstance.datePicked[0];
          endDate = pickerInstance.datePicked.length > 1 ? pickerInstance.datePicked[1] : null;
        }

        // Update hidden inputs if we have dates
        if (startDate) {
          const formattedStart = startDate.format ? startDate.format('YYYY-MM-DD') : startDate.toISOString().split('T')[0];
          this.startDateTarget.value = formattedStart;
        }

        if (endDate) {
          const formattedEnd = endDate.format ? endDate.format('YYYY-MM-DD') : endDate.toISOString().split('T')[0];
          this.endDateTarget.value = formattedEnd;
        }

        this.dateInputTarget.value = this.formatDate(startDate) + ' - ' + this.formatDate(endDate);

      } catch (error) {
        console.error('Error handling date selection:', error)
      }
    })
  }

  formatDate(date) {
    const isMobile = window.innerWidth < 768;
    
    if (isMobile) {
      const month = date.toLocaleString('en-GB', { month: 'short' });
      const day = date.getDate();
      return `${month} ${day}`;
    }
    
    return date.toLocaleDateString("en-GB", {
      weekday: "short", day: "numeric", month: "short"
    });
  }

  checkDateQueries() {
    const params = new URLSearchParams(window.location.search);
    const checkinInput = document.querySelector('input[name="checkin"]');
    const checkoutInput = document.querySelector('input[name="checkout"]');
    let checkin = params.get('checkin')
    let checkout = params.get('checkout')
    const dateInput = document.querySelector('[data-date-range-target="dateInput"]');

    // Try to get dates from session storage if not in URL params
    let storedDates = getValidatedSearchFormState();
    let storedCheckin = storedDates.dateRange?.start;
    let storedCheckout = storedDates.dateRange?.end;
    
    // Use stored dates if URL params are not present
    if (!checkin && storedCheckin) {
      checkin = storedCheckin;
    }
    if (!checkout && storedCheckout) {
      checkout = storedCheckout;
    }

    if (checkinInput && checkoutInput && checkin && checkout && dateInput) {
      checkinInput.value = checkin
      checkoutInput.value = checkout
      dateInput.value = `${this.formatDate(new Date(checkin))} - ${this.formatDate(new Date(checkout))}`
    }
  }
}
